import React from 'react';
import { CreditCard, Banknote, CheckCircle, Wallet } from 'lucide-react';
import { type PaymentModeType } from './types';

interface PaymentModeSelectorProps {
  paymentMode: PaymentModeType;
  setPaymentMode: (mode: PaymentModeType) => void;
}

const PaymentModeSelector: React.FC<PaymentModeSelectorProps> = ({ paymentMode, setPaymentMode }) => {
  const paymentOptions = [
    { id: 'offline' as const, icon: Banknote, label: 'Offline (cash)' },
    { id: 'online' as const, icon: CreditCard, label: 'Online (bank transfer)' },
    { id: 'both' as const, icon: Wallet, label: 'Both' },
  ];

  return (
    <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
      {paymentOptions.map(({ id, icon: Icon, label }) => (
        <button
          type="button"
          key={id}
          onClick={() => setPaymentMode(id)}
          className={`flex items-center gap-3 rounded-md border px-4 py-4 text-left text-sm font-medium transition-all ${
            paymentMode === id
              ? 'border-emerald-600 bg-emerald-50 text-emerald-950 ring-1 ring-emerald-200'
              : 'border-zinc-200 bg-white text-zinc-700 hover:border-zinc-300 hover:bg-zinc-50'
          }`}
        >
          <Icon className="h-5 w-5 shrink-0 text-zinc-500" />
          <span className="flex-1">{label}</span>
          {paymentMode === id && <CheckCircle className="h-5 w-5 shrink-0 text-emerald-700" />}
        </button>
      ))}
    </div>
  );
};

export default PaymentModeSelector;
